export default "__VITE_ASSET__f7ad8fb8__"